import React from 'react';

export default function Historique({ navigate }) {
  return (
    <article className="historique-page">
      <header className="historique-hero">
        <div className="historique-hero-overlay">
          <p className="historique-eyebrow">Notre histoire</p>
          <h1 className="historique-title">Aux origines<br />d’Action Directe Sahel</h1>
          <p className="historique-lede">
            De l’utopie d’un hôpital en Afrique aux puits du pays Tamberma —
            quatre décennies d’engagement.
          </p>
        </div>
      </header>

      <section className="historique-body">
        <div className="historique-inner">
          <p className="historique-lead">
            Fin 1988, peu avant sa disparition, <strong>Bernard-Marie Koltès</strong>, écrivain
            notoirement connu pour ses pièces de théâtre traduites et jouées dans le monde entier,
            déclarait dans son dernier entretien à France Culture qu’il souhaitait financer un
            hôpital en Afrique.
          </p>

          <figure className="historique-figure">
            <img
              src={process.env.PUBLIC_URL + '/bmk_elsa_ruiz.webp'}
              alt="Bernard-Marie Koltès à New-York"
            />
            <figcaption>
              Bernard-Marie Koltès — New-York, photographie d’Elsa Ruiz.
            </figcaption>
          </figure>

          <p>
            L’utopie d’un hôpital ne pouvait être réalisée, pour de multiples raisons, mais les
            droits d’auteur permirent de petites réalisations au Togo&nbsp;: la distribution
            d’antibiotiques pour les enfants au moment où souffle l’harmattan, la construction
            et l’équipement d’un dispensaire de brousse à Yaokopé, près de Sokodé, ou encore
            d’un pont de piste dans la savane près de Mango.
          </p>

          <p>
            En 1990, à l’occasion du tournage du court métrage <em>Tabataba</em> à Lomé (Togo),
            dans la cour d’une école du centre de la ville, une partie de l’équipe s’est mobilisée
            pour refaire le toit de l’école&nbsp;: il y avait de fortes pluies et les enfants ne
            pouvaient rester dans les classes. C’est ainsi que les premiers fonds provenant des
            droits d’auteur de Bernard-Marie Koltès, disparu en avril 1989, ont été utilisés
            en Afrique.
          </p>

          <p>
            En quelques années, la connaissance du milieu rural du Togo nous a amenés à comprendre
            que le premier problème dans cette région est le manque d’eau potable. Le premier puits
            a été creusé dans un village près de Mango.
          </p>

          <p>
            Parcourant la région de l’Afrique de l’Ouest située entre le Golfe de Guinée, la Volta
            et la boucle du Niger jusqu’à l’embouchure du fleuve, pour entreprendre et réaliser
            quelques actions de modeste envergure, nous avons compris à quel point le manque d’eau
            est dramatique dans les villages africains de cette grande région.
          </p>

          <p>
            Nous n’avons pas fait une découverte. Mais, entre savoir les choses et les constater
            de ses propres yeux, il y a une grande différence. Cette différence nous a amenés plus
            tard à entreprendre l’établissement de puits dans quelques villages du Togo, puis de
            la grande sous-région.
          </p>

          <p>
            D’années en années, des bénévoles se sont associés pour trouver des fonds et organiser
            des campagnes de puits. Enfin, bien après le premier toit d’école de 1990, une
            association a été créée.
          </p>

          <p className="historique-milestone">
            L’association <strong>Action Directe Sahel</strong> a été déclarée en <strong>2004</strong>.
          </p>

          <div className="historique-cta">
            <button type="button" className="link-button" onClick={() => navigate('demarche')}>
              Découvrir notre démarche →
            </button>
            <button type="button" className="link-button" onClick={() => navigate('projets')}>
              Voir les projets antérieurs →
            </button>
            <button type="button" className="link-button" onClick={() => navigate('home')}>
              ← Retour à l’accueil
            </button>
          </div>
        </div>
      </section>
    </article>
  );
}
